<template>
  <div class="main_center">
    <div class="content">
      <searchBox :dialogVisible.sync="moreSearchItem" @dialogCancle="dialogCancle" title="更多筛选">
        <div class="search-drawer">
          <el-form :model="form" label-position="top" ref="form">
            <el-form-item label="关键字搜索：">
              <el-input clearable placeholder="请输入违规事项名称" v-model="form.keywords"></el-input>
            </el-form-item>
          </el-form>
          <div class="search-drawer__footer">
            <el-button @click="searchBtn" size="small" type="primary" >搜索</el-button>
            <el-button @click="refresh" plain size="small">刷新</el-button>
          </div>
        </div>
      </searchBox>
      <div class="search-content" >
        <div class="pageTitle">联合惩戒信息登记</div>
        <div class="searchBtn centerSearch">
          <!-- <span class="label-form">关键字搜索：</span> -->
          <el-input
            @keyup.enter.native="searchBtn"
            clearable
            placeholder="请输入违规事项名称/实施认定部门/处理文件文号/企业名称"
            style="width: 500px"
            v-model="form.keywords"
          ></el-input>
          <el-button @click="searchBtn" class="rightSearchBtn height_four" size="small"  type="primary">搜索</el-button>
          <el-button
            @click="moreSearchItem = true"
            icon="el-icon-arrow-down"
            size="mini"
            type="text"
            class="height_four"
          >更多搜索</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
        </div>
      </div>
     
    </div>
    <div class="tableContent_">
        <div class="mainBtn">
          <el-button
            @click="addNew()"
            size="small"
            type="primary"
            v-if="hasBtnPermission('main_credit_punish_add')"
          >新增联合惩戒信息</el-button>
          <el-button
            @click="deleteSelectItem()"
            size="small"
            v-if="hasBtnPermission('main_credit_punish_delete')"
          >删除</el-button>
        </div>
      <el-table
        :header-cell-style="this.$globalGrayTableHeaderStyle"
        :height="tableMaxHeight"
        :data="tableData"
        border
        class="table-content"
        ref="multipleTable"
        stripe
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
        @filter-change="filterChange"
        v-loading="dataListLoading"
        @select-all="selectAll"
        row-key="id"
      >
        <el-table-column
          align="left"
          fixed
          type="selection"
          :selectable="checkSelectable"
          :reserve-selection="true"
          v-if="hasBtnPermission('main_credit_punish_delete')"
        ></el-table-column>
        <el-table-column
          :index="indexMethod"
          :show-overflow-tooltip="true"
          align="center"
          fixed
          label="序号"
          type="index"
          width="50"
        ></el-table-column>
        <el-table-column
          :filters="statusFilters"
          align="center"
          fixed
          label="状态"
          prop="statusName"
          width="100"
        >
          <template slot-scope="scope">
            <i :class="formatterStatusClass(scope.row.status)"></i>
            <span>{{ scope.row.statusName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :filters="subjectTypeFilters"
          :show-overflow-tooltip="true"
          align="left"
          fixed
          label="主体类型"
          prop="businessCode"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.punishSubjectType == '1' ? '法人' : '自然人' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          fixed
          label="主体名称"
          min-width="180"
          prop="subjectLinkName"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="联合惩戒名称"
          min-width="180"
          prop="name"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="处理文件文号"
          min-width="180"
          prop="fileName"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="实施/认定部门"
          min-width="180"
          prop="deptName"
        ></el-table-column>
        <el-table-column
          :filters="punishTypeFilters"
          :show-overflow-tooltip="true"
          align="left"
          label="处罚类型"
          min-width="150"
          prop="punishTypeName"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          :sortable="true"
          align="center"
          header-align="center"
          label="联合惩戒决定日期"
          min-width="160"
          prop="startDate"
        >
          <template scope="scope">
            <span>{{ scope.row.startDate ? formatDate(scope.row.startDate, "yyyy-MM-dd") : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          :sortable="true"
          align="center"
          header-align="center"
          label="联合惩戒结束日期"
          min-width="160"
          prop="endDate"
        >
          <template scope="scope">
            <span>{{ scope.row.endDate ? formatDate(scope.row.endDate, "yyyy-MM-dd") : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="处罚/决定内容"
          width="200"
          prop="content"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="处罚/决定依据"
          width="200"
          prop="basis"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="联合惩戒事由"
          width="200"
          prop="reason"
        ></el-table-column>
        <el-table-column
          :filters="limitBehaviorFilters"
          :show-overflow-tooltip="true"
          align="left"
          label="限制的行为"
          width="140"
          prop="limitBehaviorTypeName"
        ></el-table-column>
        <el-table-column
          :filters="scopeTypeFilters"
          :filter-method="filterPublic"
          align="center"
          header-align="center"
          label="公开范围"
          :show-overflow-tooltip="true"
          min-width="150"
          prop="scopeTypeName"
        ></el-table-column>
        <el-table-column
          sortable
          align="center"
          header-align="center"
          label="登记日期"
          :show-overflow-tooltip="true"
          min-width="155"
          prop="createTime"
        ></el-table-column>
        <el-table-column
          align="left"
          label="登记部门"
          :show-overflow-tooltip="true"
          min-width="150"
          prop="deptName"
        ></el-table-column>
        <el-table-column
          :filters="[{ text: '是', value: 'status_3' }, { text: '否', value: 'subjectType_1,2' }]"
          align="center"
          header-align="center"
          label="是否撤销"
          width="120"
          prop="flowName"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.status == '3' ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="修改人"
          min-width="140"
          prop="updateUser"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          :sortable="true"
          align="center"
          header-align="center"
          label="修改时间"
          min-width="155"
          prop="updateTime"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="创建人"
          min-width="140"
          prop="createUser"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          sortable
          align="center"
          header-align="center"
          label="创建时间"
          min-width="155"
          prop="createTime"
        ></el-table-column>
        <el-table-column align="left" header-align="center" fixed="right" label="操作" width="160">
          <template slot-scope="scope">
            <!-- <el-button @click="routerDetail(scope.row, (scope.row.status == 1 ? 'edit' : 'view'))" type="text"
            v-if="scope.row.status != 1 || scope.row.canModify">查看</el-button>-->
            <el-button
              @click="routerDetail(scope.row, (scope.row.canModify && scope.row.status == 1 ? 'edit' : 'view'))"
              type="text"
              v-if="hasBtnPermission('main_credit_punish_view')"
            >查看</el-button>
            <el-button
              @click="routerDetail(scope.row, 'copy')"
              type="text"
              v-if="hasBtnPermission('main_credit_punish_copy')"
            >复制</el-button>
            <el-divider
              direction="vertical"
              v-if="(scope.row.canModify && scope.row.status != 3 && (hasBtnPermission('main_credit_punish_commit') || hasBtnPermission('main_credit_punish_delete') || hasBtnPermission('main_credit_punish_add') || hasBtnPermission('main_credit_punish_revoke')))"
            ></el-divider>
            <el-popover placement="right" popper-class="btnPopver" trigger="click" width="200px">
              <div class="btnBox">
                <el-button
                  @click="commitData(scope.row)"
                  type="text"
                  v-if="scope.row.status == 1 && hasBtnPermission('main_credit_punish_commit')"
                >提交</el-button>
                <el-button
                  @click="routerDetail(scope.row, 'edit')"
                  type="text"
                  v-if="scope.row.status == 2 && hasBtnPermission('main_credit_punish_add')"
                >修改</el-button>
                <el-button
                  @click="deleteById(scope.row)"
                  type="text"
                  v-if="scope.row.status == 1 && hasBtnPermission('main_credit_punish_delete')"
                >删除</el-button>
                <el-button
                  @click="showRevokeForm(scope.row)"
                  type="text"
                  v-if="scope.row.status == 2 && hasBtnPermission('main_credit_punish_revoke')"
                >撤销</el-button>
              </div>
              <el-button
                slot="reference"
                type="text"
                v-if="(scope.row.canModify && scope.row.status != 3 && (hasBtnPermission('main_credit_punish_commit') || hasBtnPermission('main_credit_punish_delete') || hasBtnPermission('main_credit_punish_add') || hasBtnPermission('main_credit_punish_revoke')))"
              >
                更多
                <i class="el-icon-arrow-down"></i>
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="pageIndex"
        :page-size="pageSize"
        :page-sizes="[pageSize, 20, 50, 100]"
        :total="total"
        @current-change="currentChangeHandle"
        @size-change="sizeChangeHandle"
        background
        layout="total, sizes, prev, pager, next"
        style="padding-bottom:12px;"
      ></el-pagination>
    </div>
    <revokeDia :type="'2'" @revokeSuccess="getDataList" ref="revokeDiaRef"></revokeDia>
  </div>
</template>

<script>
import {
  getIllegalListData,
  deleteIllegalData,
  commitIllegalData
} from "@/server/mainCredit.js";
import revokeDia from "../components/revokeDia/index";
import { mapState } from "vuex";
export default {
  name: "busWitnessTable",
  components: {
    revokeDia
  },
  data() {
    return {
      tableMaxHeight: document.documentElement.clientHeight - 363,
      dataListLoading: false,
      businessTypeNamelist: [],
      witnessStatuslist: [],
      form: {
        keywords: "",
        flowName: ""
      },
      statusFilters: [],
      subjectTypeFilters: [],
      punishTypeFilters: [],
      scopeTypeFilters: [],
      limitBehaviorFilters: [],
      filters: {},
      sortParams: {
        order: "",
        prop: ""
      },
      moreSearchItem: false,
      pageSize: 10, //每页条数
      pageIndex: 1, //当前页
      total: 0, //总条数
      tableData: [],
      multipleSelection: []
    };
  },
  props: {},
  filters: {},
  computed: {
    ...mapState({
      mainTypeList: state => state.dataDictionary.mainTypeList,
      publicScopeList: state => state.dataDictionary.publicScopeList,
      punishTypeList: state => state.dataDictionary.punishTypeList,
      punishLimitList: state => state.dataDictionary.punishLimitList
    })
  },
  watch: {
    mainTypeList: {
      immediate: true,
      deep: true, // 深度监听
      handler(val, newVal) {
        this.$nextTick(() => {
          let filters = [];
          this.mainTypeList.forEach(item => {
            filters.push({
              text: item.name,
              value: "subjectType_" + item.value
            });
          });
          this.subjectTypeFilters = filters;
        });
      }
    },
    publicScopeList: {
      immediate: true,
      deep: true, // 深度监听
      handler(val, newVal) {
        this.$nextTick(() => {
          let filters = [];
          this.publicScopeList.forEach(item => {
            filters.push({
              text: item.name,
              value: "subjectType_" + item.value
            });
          });
          this.scopeTypeFilters = filters;
        });
      }
    },
    punishTypeList: {
      immediate: true,
      deep: true, // 深度监听
      handler(val, newVal) {
        this.$nextTick(() => {
          let filters = [];
          this.punishTypeList.forEach(item => {
            filters.push({
              text: item.name,
              value: "punishType_" + item.value
            });
          });
          this.punishTypeFilters = filters;
        });
      }
    },
    punishLimitList: {
      immediate: true,
      deep: true, // 深度监听
      handler(val, newVal) {
        this.$nextTick(() => {
          let filters = [];
          this.punishLimitList.forEach(item => {
            filters.push({
              text: item.name,
              value: "limitBehaviorType_" + item.value
            });
          });
          this.limitBehaviorFilters = filters;
        });
      }
    }
  },
  created() {
    this.$store.dispatch("dataDictionary/getMainTypeList"); //获取主体类型
    this.$store.dispatch("dataDictionary/getPunishTypeList"); //获取处罚类型数据
    this.$store.dispatch("dataDictionary/getMainRevokeAttList"); // 获取撤销附件配置项数据
    this.$store.dispatch("dataDictionary/getPublicScopeList"); // 获取公开范围
    this.$store.dispatch("dataDictionary/getPunishLimitList"); // 获取限制的行为字典
    this.getStatusList();
  },
  activated() {
    // this.refresh();
  },

  mounted() {
    const that = this;
    let resizeTag = true;
    window.onresize = () => {
      if (resizeTag) {
        //防抖动
        that.ifmove();
        resizeTag = false;
        setTimeout(() => {
          resizeTag = true;
        }, 1000);
      }
    };
    that.ifmove();
    this.getDataList();
  },
  methods: {
    selectAll(selection) {
      if (selection.length == 0) {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 判断表格行是否可选
    checkSelectable(row, index) {
      /**
       * row：当前行数据
       * index：当前第几位
       */
      let flag = true;
      if (
        row.status == 1 &&
        row.canModify &&
        this.hasBtnPermission("main_credit_punish_delete")
      ) {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    },
    filterPublic(value, row) {
      let flag;
      if (value == "subjectType_2") {
        flag = "政务公开";
      } else {
        flag = "社会公开";
      }
      return row.scopeTypeName === flag;
    },
    computeBtnLenth(item) {
      if (this.hasBtnPermission("main_credit_exposal_commit")) {
        item.btnLength = 1;
      } else if (this.hasBtnPermission("main_credit_exposal_add")) {
        item.btnLength = 1;
      } else if (this.hasBtnPermission("main_credit_exposal_delete")) {
        item.btnLength = 1;
      } else if (this.hasBtnPermission("main_credit_exposal_revoke")) {
        item.btnLength = 1;
      } else {
        item.btnLength = 0;
      }

      return item.btnLength;
    },
    dialogCancle() {
      this.moreSearchItem = false;
    },
    ifmove() {
      let tableMaxHeight = document.documentElement.clientHeight - 363;
      this.pageSize = parseInt(tableMaxHeight / 57) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight;
      });
      // this.getDataList()
    },

    formatterStatusClass(historyId) {
      switch (historyId) {
        case 1:
          return "icon-point icon-point-verificationing";
          break;
        case 2:
          return "icon-point icon-point-success";
          break;
        case 3:
          return "icon-point icon-point-info";
          break;
        default:
          return "";
          break;
      }
    },
    getStatusList() {
      this.$httpReq.get("/complaint/listEnum/StatusEnum").then(res => {
        if (res.data.code === "1") {
          // { text: '待提交', value: 'status_1' },{ text: '资审澄清与修改文件', value: 'dataType_4' }
          let filters = [];
          res.data.data.forEach(item => {
            filters.push({
              text: item.name,
              value: "status_" + item.code
            });
          });
          this.statusFilters = filters;
        }
      });
    },

    addNew() {
      removeTabHandle("credit_punish_detail");
      this.$router.push({
        name: "credit_punish_detail",
        query: {
          id: ""
        }
      });
    },

    getDataList() {
      // 获取列表数据
      this.dataListLoading = true;
      this.filters.dataType = "4"; // 数据类型 1违法违规 2行政处罚 3黑名单 4联合惩戒
      getIllegalListData({
        page: this.pageIndex,
        rows: this.pageSize,
        searchKey: this.form.keywords,
        orderBy:
          this.sortParams.prop && this.sortParams.order
            ? this.sortParams.prop +
              (this.sortParams.order == "ascending" ? " asc" : " desc")
            : "",
        filter: this.filters
      }).then(res => {
        this.tableData = res.data.rows;
        this.tableData.forEach(item => {
          // 提交注释
          // item.canModify=true;
          item.btnLength = this.computeBtnLenth(item);
        });
        this.total = res.data.total;
        this.$refs.multipleTable.doLayout();
        this.dataListLoading = false;
      });
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },

    filterChange(filters) {
      let filtersParams = {};
      for (var i in filters) {
        var filtersArr = filters[i];
        let key = "",
          value = [];
        filtersArr.length > 0 &&
          filtersArr.forEach(item => {
            key = item.split("_")[0];
            value.push(item.split("_")[1]);
          });
        key && value.length > 0
          ? (filtersParams[key] = value.toString())
          : null;
      }
      if(filtersParams.status){
        filtersParams.statusList=filtersParams.status.split(",")
        delete filtersParams.status
      }
      if(filtersParams.subjectType){
        filtersParams.punishSubjectTypeList=filtersParams.subjectType.split(",")
        delete filtersParams.subjectType
      }
      if(filtersParams.punishType){
        filtersParams.punishTypeList=filtersParams.punishType.split(",")
        delete filtersParams.punishType
      }
      this.filters = filtersParams;
      this.getDataList();
    },
    sortChange(column, prop, order) {
      this.sortParams.prop = prop || column.prop;
      this.sortParams.order = order || column.order;
      this.getDataList();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    //搜索按钮
    searchBtn() {
      this.pageIndex = 1;
      this.moreSearchItem = false;
      this.getDataList();
    },

    refresh() {
      //刷新按钮
      this.pageIndex = 1;
      this.moreSearchItem = false;
      this.form.keywords = "";
      this.form.datasetCode = "-1";
      this.form.witnessStatus = "-1";
      this.getDataList();
    },

    routerDetail(item, flag) {
      // 跳转详情

      if (flag == "view") {
        removeTabHandle("credit_punish_view");
        this.$router.push({
          name: "credit_punish_view",
          query: {
            id: item.id
          }
        });
      }

      if (flag == "edit" || flag == "copy") {
        removeTabHandle("credit_punish_detail");
        this.$router.push({
          name: "credit_punish_detail",
          query: {
            id: item.id,
            copy: flag == "copy" ? true : false
          }
        });
      }
    },
    showRevokeForm(data) {
      this.$refs.revokeDiaRef.initDialog(data);
    },
    commitData(item) {
      this.$confirm(`确认提交吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        commitIllegalData({
          id: item.id
        }).then(res => {
          if (res.data.code == "1") {
            this.$message({
              type: "success",
              message: "提交成功！"
            });
            this.getDataList();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        });
      });
    },
    deleteById(item) {
      this.$confirm(
        `<div style="text-align:center;font-size:16px">确认删除吗?<p style="font-size:12px">删除后的数据不可恢复</p></div>`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        deleteIllegalData({
          id: item.id
        }).then(res => {
          if (res.data.code == "1") {
            this.$message({
              type: "success",
              message: "数据删除成功！"
            });
            this.getDataList();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        });
      });
    },

    deleteSelectItem() {
      let ids = new Array();
      this.multipleSelection.forEach(key => {
        ids.push(key.id);
      });
      if (ids != "" || ids.length > 0) {
        this.$confirm(
          `<div style="text-align:center;font-size:16px">确认删除吗?<p style="font-size:12px">删除后的数据不可恢复</p></div>`,
          "提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          deleteIllegalData({
            idList: ids
          }).then(res => {
            if (res.data.code == "1") {
              this.$message({
                type: "success",
                message: "数据删除成功！"
              });
              this.getDataList();
            } else {
              this.$message({
                type: "error",
                message: res.data.msg
              });
            }
          });
        });
      } else {
        this.$message({
          type: "error",
          message: "未选择删除项。"
        });
      }
    }
  },

  destroyed() {
    window.onresize = null;
  }
};
</script>

<style lang="scss">
.content{
    .centerSearch{
        .el-input .el-input__inner, .el-input--medium .el-input__inner, .el-input--suffix .el-input__inner{
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    .rightSearchBtn{
        height:40px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    .height_four{
      height: 40px;
    }
     .el-input--medium .el-input__inner{
            height: 40px;
            line-height: 40px;
        }
    }
}
</style>

<style lang="scss" scoped>
.main_center {
     .el-button--primary:hover{
        background-color: #1890FF;
        opacity: .85;
     }
     .content{
        padding:24px;
     }
  .search-content {
    display: flex;
    align-items: center;
    .searchBtn {
     width:calc(100% - 180px);
     height:40px;
    float: none;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    }
    .pageTitle{
        font-size: 18px;
        font-weight: 600;
        color: #000000; 
        height: 40px; 
        margin-top:-9px;
    }
  }
  .search-content > div{
     line-height: normal;
     padding:0;
  }
  .mainBtn{
    padding:15px;
  }
}

.btnBox {
  display: flex;
  flex-direction: column;

  .el-button {
    margin-left: 0px;
    margin-top: 10px;
  }
}
</style>
